import numeral from "numeral";

export const numberWithCommas = (x) => {
  x = parseFloat(x).toFixed(2);
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumber = (value, decimals = 2) => {
  const sufix = decimals ? `.${'0'.repeat(decimals)}` : ''
  return numeral(value).format(`0,0${sufix}`)
}

export const formatMoney = ( x ) => {
  let fixedStringNumber = parseFloat(x).toFixed(2);
  let isLessThan0 = false;

  let floatNumber = parseFloat( fixedStringNumber )

  if( floatNumber < 0 ) {
    fixedStringNumber = Math.abs( floatNumber ).toFixed(2)
    floatNumber = parseFloat( fixedStringNumber )
    isLessThan0 = true;
  }

  return isLessThan0 ? `(${ floatNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") })` : floatNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
}